import { Popper } from '@mui/material'
import type { ReactNode } from 'react'
import styles from './HourlyDataTable.module.less'

type HourlyInputCellFaultDisclosureProps = {
  descriptionId: string
  message: string
  anchorElement: HTMLTableCellElement | null
  isOpen: boolean
}

export function HourlyInputCellFaultDisclosure({
  descriptionId,
  message,
  anchorElement,
  isOpen,
}: HourlyInputCellFaultDisclosureProps): ReactNode {
  return (
    <>
      <span id={descriptionId} className={styles.HourlyDataTable_BidTableCellFaultDescription}>
        {message}
      </span>
      <Popper
        open={isOpen}
        anchorEl={anchorElement}
        placement="bottom-start"
        className={styles.HourlyDataTable_BidTableCellFaultPopper}
        sx={{ zIndex: (theme) => theme.zIndex.snackbar - 1 }}
        aria-hidden="true"
      >
        <div className={styles.HourlyDataTable_BidTableCellFaultPopover}>{message}</div>
      </Popper>
    </>
  )
}
